import React from "react";
import "./faq.css";
import { useState } from "react";
import { HiOutlineChevronDown } from "react-icons/hi";
const Faq = () => {
  const [faqs, setFaqs] = useState([
    {
      id: 1,
      active: true,
      question: "WHAT iS QUANTUM ASSETS GLOBAL LEDGER?",
      answer:
        "Quantum Assests Global Ledger is a wallet/digital asset secure system, which gives immunity against cyber attacks and bad market fluctuations.",
    },
    {
      id: 2,
      active: false,
      question: "DOES IT MATTER IF I AM NEW TO CRYPTO/DIGITAL MARKET?",
      answer:
        "No, it doesn't matter if you are new to crypto/digital market, you can still use Quantum Assests Global Ledger to secure your digital assets.",
    },
    {
      id: 3,
      active: false,
      question: "IS SIGN-UP FREE?",
      answer:
        "Yes! register a free account with Quantum Assets Global Ledger, and make your first step to securing your crypto wallet/digital asssets.",
    },
    {
      id: 4,
      active: false,
      question: "HOW DO I START?",
      answer:
        "First register a free account, verify your reqistered account then login to your user dashboard, on your dashboard click on secure wallet/asset, and follow the instructions to secure your wallet.",
    },
    {
      id: 5,
      active: false,
      question: "HOW CAN QUANTUM FINANCIAL SYSTEM HELP MY FINANCIAL STATUS?",
      answer:
        "Quantum Assests Global Ledger is a crypto wallet/digital asset vault which protects your crypto wallet from bad market fluctuations and cryto fraud.",
    },

    {
      id: 5,
      active: false,
      question: "WHEN TO GET PAYOUT?",
      answer:
        "Quantum Assests Global Ledger Payouts and other Transactions are seamless and processed automatically by the system.",
    },
  ]);

  const dropDown = (id) => {
    setFaqs(
      faqs.map((faq) =>
        faq.id === id
          ? { ...faq, active: !faq.active }
          : { ...faq, active: false }
      )
    );
    console.log(faqs);
  };
  return (
    <div className="faq-section" id="faq">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1919 274"
        className="svg-line"
      >
        <path
          fill="none"
          stroke="#565674"
          stroke-dasharray="12"
          d="M-150,908.21396 C-151.16508,816.022735 -42.010869,767.607158 177.462632,762.967229 C506.672884,756.007334 405.185109,537.831699 865.446032,604.840708 C1325.70696,671.849717 1270.71837,423 1687.44603,540.526473 C2104.17369,658.052946 2011.79501,428.896794 2076.92909,423 C2075.67597,582.585165 2075.67597,744.323151 2076.92909,908.21396 L-150,908.21396 Z"
          opacity=".5"
          transform="translate(-1 -508)"
        />
      </svg>
      <div className="faq-wrapper">
        <div className="why-choose-us-text-container faq-p">
          <div className="header" data-aos="fade-up">
            <span className="header-line"></span>
            <h2>faq</h2>
          </div>
          <h1 data-aos="fade-up">frequently asked questions</h1>
          <p data-aos="fade-up">
            We’ve provided some information about Quantum Assests Global Ledger,
            Quantum Assests Global Ledger Plans, cryptocurrencies, and few other
            common questions you might want to ask. If you have any other
            questions, contact our live support system or email address.
          </p>
        </div>
      </div>
      <div className="faq-container">
        {faqs.map((faq) => (
          <div className="faq-card" key={faq.id} data-aos="fade-up">
            <div className="question-tab">
              <h2>{`${faq.question}`}</h2>
              <span
                className={`dropdown-btn ${faq.active && "rotate"}`}
                onClick={() => {
                  dropDown(faq.id);
                }}
              >
                <HiOutlineChevronDown />
              </span>
            </div>

            <div className={`answer-tab ${faq.active && "drop"}`}>
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faq;
